import { render, staticRenderFns } from "./ModalConfigInfo.vue?vue&type=template&id=5a7b8528&scoped=true"
import script from "./ModalConfigInfo.vue?vue&type=script&lang=js"
export * from "./ModalConfigInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigInfo.vue?vue&type=style&index=0&id=5a7b8528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b8528",
  null
  
)

export default component.exports